
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { IUserDetailData } from "@/entities";

@Component({
  name: "help-advise-form",
})
export default class HelpAdviseForm extends Vue {
  @Getter("getLoggedUser") getLoggedUser!: IUserDetailData;
  @Prop({ required: true })
  minimunIntervalTime!: number;
  @Prop({ required: true })
  minimunHour!: number;
  @Prop({ required: true })
  maximunHour!: number;
  @Prop({ required: true })
  minimunStartingInterval!: number;

  constructor() {
    super();
  }
}
